import { generateUUID } from '../helpers/generateRandomUuid';
import { isMockRunning } from '../helpers/isMockRunning';

export const IS_DEMO_MODE_ON = localStorage.getItem('DEMO_MODE_ON') === 'true';
const defaultMockCondition = () => isMockRunning();
// eslint-disable-next-line local-rules/enforce-demo-mode-comment-and-import
const defaultMockConditionOrMockDemoMode = () => defaultMockCondition() || IS_DEMO_MODE_ON;
export const IS_MOCK_ENABLED = (params?: { avoidMockOnDemoMode: boolean }): boolean => {
  const { avoidMockOnDemoMode } = params ?? { avoidDemo: false };
  return avoidMockOnDemoMode ? defaultMockCondition() : defaultMockConditionOrMockDemoMode();
};
export const USER_EMAIL = 'utente_demo_001@altermaind.com';
export const ORGANIZATION_ID = 'a9663257-a7de-4309-927e-f328c2337138';
export const RANDOM_UIID = () => generateUUID();
